
import { FSharpRef, Record, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { option_type, int32_type, record_type, string_type, union_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { Text_div, Common_GenericOption, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { Option, notification } from "../fable_modules/Fulma.3.0.0/Elements/Notification.fs.js";
import { pinSvg, leftSectionWidth, notificationStyle } from "./Style.js";
import { collect, append as append_1, isEmpty, filter, cons, iterate, map as map_1, find, tryFind, empty, ofArray, singleton } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { Option as Option_1, delete$ } from "../fable_modules/Fulma.3.0.0/Elements/Delete.fs.js";
import { sheetMenuPinned_, UICommandType, MenuCommand, TopMenu, savedSheetIsOutOfDate_, projectOpt_, FileCommandType, TTMsg, Model, Msg } from "../Model/ModelType.js";
import * as react from "react";
import { mapIndexed, tryPick } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { toText, printf, toFail, padLeft, concat, format, isNullOrWhiteSpace, trimStart, split, compare } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { comparePrimitives, uncurry3, defaultOf, equals, unescapeDataString } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList, chunkBySize, map, toArray, forAll } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { isDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { min, max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { StringModule_Length, StringModule_Concat } from "../Common/EEExtensions.js";
import { tryParse } from "../fable_modules/fable-library-js.5.13.0/Int32.js";
import { copiesOfArray, Rotation, loadedComponentIsOutOfDate_, formOpt_, loadedComponentOf_, Component, ComponentType, CustomComponentType, LoadedComponent, JSDiagramMsg, Project, SheetInfo as SheetInfo_1, CCForm } from "../Common/CommonTypes.js";
import { getUpdatedLoadedComponents, getComponentIds, openSheetIsReadOnly, updateLdCompsWithCompOpt, getSavedWaveInfo, designWithSheet } from "./ModelHelpers.js";
import { getHintPaneElement, Constants_numCharsHidePath, openFileInProject, allRootSheets, librarySheetsShown, getSheetTreesFiltered, Constants_minNumPathChars, Constants_maxNumPathChars, Constants_largeScreenCanvasWidth, foldOverTree, recentProjects, openProjectFromPath, Constants_maxDisplayedPathLengthInRecentProjects, recentProjectItem, displayFileErrorNotification, openDemoProjectFromPath, warnAppWidth, openFileInProject$0027, isFileInProject, setupProjectFromComponents, saveOpenFileAction, updateProjectFromCanvas, writeComponentToBackupFile, getSavedWave } from "./MenuHelpers.js";
import { displayAlertOnError } from "./Notifications.js";
import { createEmptySheetFile, writeAllSheetFiles, sheetFilePath, writeSheetFile } from "../Interface/ComponentLibraries.js";
import { loadBundledDemoAsync, hasExtn, copyFile, mkdir, clearBrowserStoredPath, writeFile, readFilesFromDirectory, unlink, tryUserDemosDirectory, tryEnsureDirectory, staticDir, dirName, renameFile, pathJoin, createEmptyDgmFile, makeLoadedComponentFromCanvasData, removeFileWithExtn } from "../Interface/FilesIO.js";
import { tryFind as tryFind_1 } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { now } from "../fable_modules/fable-library-js.5.13.0/Date.js";
import { DrawModelType_SymbolT_ThemeType, DrawModelType_SheetT_WireTypeMsg, DrawModelType_SheetT_Arrange, DrawModelType_SheetT_KeyboardMsg, DrawModelType_SheetT_Msg, DrawModelType_BusWireT_Msg, DrawModelType_SymbolT_Msg } from "../Model/DrawModelType.js";
import { value as value_6, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { unclosablePopup, dynamicClosablePopup, getText, dialogPopupBodyOnlyText, dialogPopup } from "../DrawBlock/PopupHelpers.js";
import { allRootHierarchiesFromProjectBreadcrumbs, BreadcrumbConfig, Constants_defaultConfig, maybeWarning } from "./MiscMenuView.js";
import { dbg, warn as warn_1 } from "../Shared/Log.js";
import { Result_Bind } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { Item_Option, Item_li, list as list_3, menu } from "../fable_modules/Fulma.3.0.0/Components/Menu.fs.js";
import { cropToLength } from "../Common/Helpers.js";
import { viewInfoPopup, PasteArray_pasteArrayPopup, PasteArray_arrayChoices, viewInfoPopupAtTab } from "./UIPopups.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { dataTooltip } from "../fable_modules/Fulma.Extensions.Wikiki.Tooltip.4.0.0/Tooltip.fs.js";
import { Optic_Set_op_HatEquals_Z147477F8, Optic_Set, Optic_Set_op_HatEquals_Z32E30375, Compose_Prism, Compose_Prism_op_GreaterQmarkGreater_507FA136, Optic_Map, Optic_Map_op_HatPercent_Z32F545AB } from "../Common/Optics.js";
import { isMac } from "../Interface/Bridge.js";
import { End_div, Link_Option, Brand_div, Option as Option_2, navbar, divider, Link_a, Dropdown_Option, Dropdown_div, Item_div, Item_Option as Item_Option_1, Item_a } from "../fable_modules/Fulma.3.0.0/Components/Navbar.fs.js";
import { ShortcutId, idLabel } from "../Common/KeyTypes.js";
import { moveCustomPortsPopup } from "../DrawBlock/SymbolPortHelpers.js";
import { effectiveTopSheetFor, projectHasAmbiguousDisplay } from "../Common/ParameterAnalysis.js";
import { contains, empty as empty_2, ofList } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { Constants_sheetMenuId, isAtFittedPosition, fitWindowFor } from "../DrawBlock/Sheet.js";
import { Option as Option_3, breadcrumb, Item_Option as Item_Option_2, item } from "../fable_modules/Fulma.3.0.0/Components/Breadcrumb.fs.js";
import { Option as Option_4, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";

class HashNoticeKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["HashSuccess", "HashWarning", "HashError"];
    }
    static HashSuccess = new HashNoticeKind(0, []);
    static HashWarning = new HashNoticeKind(1, []);
    static HashError = new HashNoticeKind(2, []);
}

function HashNoticeKind_$reflection() {
    return union_type("TopMenuView.HashNoticeKind", [], HashNoticeKind, () => [[], [], []]);
}

class HashNotice extends Record {
    constructor(Kind, Line1, Line2) {
        super();
        this.Kind = Kind;
        this.Line1 = Line1;
        this.Line2 = Line2;
    }
}

function HashNotice_$reflection() {
    return record_type("TopMenuView.HashNotice", [], HashNotice, () => [["Kind", HashNoticeKind_$reflection()], ["Line1", string_type], ["Line2", string_type]]);
}

class HashDemoRequest extends Record {
    constructor(DemoId, DemoBasename, DemoDisplayName, InitRamOverride, Notice) {
        super();
        this.DemoId = (DemoId | 0);
        this.DemoBasename = DemoBasename;
        this.DemoDisplayName = DemoDisplayName;
        this.InitRamOverride = InitRamOverride;
        this.Notice = Notice;
    }
}

function HashDemoRequest_$reflection() {
    return record_type("TopMenuView.HashDemoRequest", [], HashDemoRequest, () => [["DemoId", int32_type], ["DemoBasename", string_type], ["DemoDisplayName", string_type], ["InitRamOverride", option_type(string_type)], ["Notice", HashNotice_$reflection()]]);
}

class HashLaunchRequest extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NoHashAction", "ShowHashNotice", "LoadHashDemo"];
    }
    static NoHashAction = new HashLaunchRequest(0, []);
}

function HashLaunchRequest_$reflection() {
    return union_type("TopMenuView.HashLaunchRequest", [], HashLaunchRequest, () => [[], [["Item", HashNotice_$reflection()]], [["Item", HashDemoRequest_$reflection()]]]);
}

const hashSuccessHint = "Go to Simulations and try running it!";

const hashCodePreviewLimit = 16;

function makeHashNotice(kind, line1, line2) {
    return new HashNotice(kind, line1, line2);
}

function showHashNotice(dispatch, notice) {
    let color;
    const matchValue = notice.Kind;
    color = ((matchValue.tag === 1) ? Color_IColor.IsWarning : ((matchValue.tag === 2) ? Color_IColor.IsDanger : Color_IColor.IsSuccess));
    return dispatch(new Msg(/* SetFilesNotification */ 79, [(dispatch$0027) => notification(ofArray([new Option(/* Color */ 0, [color]), new Option(/* Props */ 3, [singleton(notificationStyle)])]), ofArray([delete$(singleton(new Option_1(/* OnClick */ 3, [(_arg) => {
        dispatch$0027(Msg.CloseFilesNotification);
    }])), empty()), notice.Line1, react.createElement("br", {}), notice.Line2]))]));
}

function tryGetHashValue(key, hash) {
    return tryPick((segment) => {
        const index = segment.indexOf("=") | 0;
        if (index <= 0) {
            return undefined;
        }
        else {
            const rawKey = segment.slice(0, (index - 1) + 1);
            const rawValue = segment.slice(index + 1, segment.length);
            if (compare(rawKey, key, 5) === 0) {
                return unescapeDataString(rawValue);
            }
            else {
                return undefined;
            }
        }
    }, split(trimStart(hash.trim(), "#"), ["&"], undefined, 1));
}

function tryGetDemoInfo(demoId) {
    switch (demoId) {
        case 1:
            return ["1fulladder", "fulladder"];
        case 2:
            return ["2adder (4-bit)", "adder (4-bit)"];
        case 3:
            return ["3cpu", "cpu"];
        case 4:
            return ["4registerFile", "registerFile"];
        case 5:
            return ["5eratosthenes", "eratosthenes"];
        case 6:
            return ["6pipeline", "pipeline"];
        case 7:
            return ["7interupt", "interupt"];
        default:
            return undefined;
    }
}

function supportsHashCode(demoId) {
    switch (demoId) {
        case 3:
        case 6:
        case 7:
            return true;
        default:
            return false;
    }
}

function isHexString(value) {
    return forAll((ch) => {
        if (isDigit(ch)) {
            return true;
        }
        else {
            const lower = ch.toLowerCase();
            if (lower >= "a") {
                return lower <= "f";
            }
            else {
                return false;
            }
        }
    }, value.split(""));
}

function truncateHashCodeForMessage(code) {
    const normalized = code.trim().toLowerCase();
    if (normalized.length <= hashCodePreviewLimit) {
        return normalized;
    }
    else {
        return normalized.slice(0, (hashCodePreviewLimit - 1) + 1) + "...";
    }
}

function formatHashCodeAsInitRam(hexCode) {
    let copyOfStruct;
    const normalized = hexCode.trim().toLowerCase();
    if (isNullOrWhiteSpace(normalized)) {
        return undefined;
    }
    else if (((normalized.length % 4) !== 0) ? true : !isHexString(normalized)) {
        return undefined;
    }
    else {
        const words = toArray(map((value) => (value.join('')), chunkBySize(4, normalized.split(""))));
        const addressWidth = max(2, ((copyOfStruct = (max(0, words.length - 1) | 0), format('{0:' + "x" + '}', copyOfStruct))).length) | 0;
        return StringModule_Concat("\n", mapIndexed((index, word) => concat("0x", padLeft(format('{0:' + "x" + '}', index), addressWidth, "0"), "\t0x", word), words));
    }
}

function tryParseHashDemoRequest() {
    const hash = window.location.hash || '';
    if (window.location.hash) { history.replaceState(null, '', window.location.pathname + window.location.search); };
    const matchValue = tryGetHashValue("demo", hash);
    if (matchValue != null) {
        const demoValue = matchValue;
        let matchValue_1;
        let outArg = 0;
        matchValue_1 = [tryParse(demoValue, 511, false, 32, new FSharpRef(() => (outArg | 0), (v) => {
            outArg = (v | 0);
        })), outArg];
        if (matchValue_1[0]) {
            const demoId = matchValue_1[1] | 0;
            const matchValue_2 = tryGetDemoInfo(demoId);
            if (matchValue_2 != null) {
                const demoDisplayName = matchValue_2[1];
                const demoBasename = matchValue_2[0];
                const demoLabel = `demo ${demoId} ${demoDisplayName}`;
                const matchValue_3 = tryGetHashValue("code", hash);
                let matchResult, rawCode_1, rawCode_2;
                if (matchValue_3 != null) {
                    if (matchValue_3 === "") {
                        matchResult = 0;
                    }
                    else if (!supportsHashCode(demoId)) {
                        matchResult = 1;
                        rawCode_1 = matchValue_3;
                    }
                    else {
                        matchResult = 2;
                        rawCode_2 = matchValue_3;
                    }
                }
                else {
                    matchResult = 0;
                }
                switch (matchResult) {
                    case 0:
                        return new HashLaunchRequest(/* LoadHashDemo */ 2, [new HashDemoRequest(demoId, demoBasename, demoDisplayName, undefined, makeHashNotice(HashNoticeKind.HashSuccess, concat(demoLabel, " is successfully loaded."), hashSuccessHint))]);
                    case 1:
                        return new HashLaunchRequest(/* LoadHashDemo */ 2, [new HashDemoRequest(demoId, demoBasename, demoDisplayName, undefined, makeHashNotice(HashNoticeKind.HashWarning, concat(demoLabel, " is successfully loaded, but code \'", truncateHashCodeForMessage(rawCode_1), "\' is ignored. Machine code is only supported in demo 3, 6 and 7."), hashSuccessHint))]);
                    default: {
                        const preview_1 = truncateHashCodeForMessage(rawCode_2);
                        const matchValue_4 = formatHashCodeAsInitRam(rawCode_2);
                        if (matchValue_4 == null) {
                            return new HashLaunchRequest(/* LoadHashDemo */ 2, [new HashDemoRequest(demoId, demoBasename, demoDisplayName, undefined, makeHashNotice(HashNoticeKind.HashWarning, concat(demoLabel, " is successfully loaded, but code \'", preview_1, "\' is invalid and has been ignored. Machine code must be a hexadecimal string whose length is a multiple of 4."), hashSuccessHint))]);
                        }
                        else {
                            return new HashLaunchRequest(/* LoadHashDemo */ 2, [new HashDemoRequest(demoId, demoBasename, demoDisplayName, matchValue_4, makeHashNotice(HashNoticeKind.HashSuccess, concat(demoLabel, " with code \'", preview_1, "\' is successfully loaded."), hashSuccessHint))]);
                        }
                    }
                }
            }
            else {
                return new HashLaunchRequest(/* ShowHashNotice */ 1, [makeHashNotice(HashNoticeKind.HashError, `demo ${demoId} is invalid and has been ignored.`, "Please use demo 1 to 7.")]);
            }
        }
        else {
            return new HashLaunchRequest(/* ShowHashNotice */ 1, [makeHashNotice(HashNoticeKind.HashError, concat("The hash demo value \'", demoValue, "\' is invalid and has been ignored."), "Please use demo 1 to 7.")]);
        }
    }
    else {
        return HashLaunchRequest.NoHashAction;
    }
}

/**
 * Save the Verilog file currently open, return the new sheet's Loadedcomponent if this has changed.
 * Do not change model.
 */
export function updateVerilogFileAction(newCS_, newCS__1, name, model, dispatch) {
    let option_1;
    const newCS = [newCS_, newCS__1];
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        const sheetInfo = new SheetInfo_1(new CCForm(/* Verilog */ 4, [name]), undefined, undefined, (option_1 = tryFind((lc) => (lc.Name === name), project.LoadedComponents), (option_1 != null) ? option_1.IsTopSheet : undefined), undefined);
        const design = designWithSheet(project, name, newCS[0], newCS[1]);
        const savedState = [newCS, getSavedWave(design, model), sheetInfo];
        displayAlertOnError(dispatch, writeSheetFile(sheetFilePath(project, name), savedState[0], savedState[1], savedState[2]));
        removeFileWithExtn(".dgmauto", project.ProjectPath, name);
        const origLdComp = find((lc_2) => (lc_2.Name === name), project.LoadedComponents);
        let savedWaveSim;
        const option_3 = tryFind_1(name, model.WaveSim);
        savedWaveSim = ((option_3 != null) ? getSavedWaveInfo(design, name, option_3) : undefined);
        let SheetInfo;
        const matchValue_1 = origLdComp.Form;
        SheetInfo = ((matchValue_1 != null) ? (new SheetInfo_1(matchValue_1, origLdComp.Description, origLdComp.LCParameterSlots, origLdComp.IsTopSheet, origLdComp.ArrayInfo)) : undefined);
        const patternInput = makeLoadedComponentFromCanvasData(newCS[0], newCS[1], origLdComp.FilePath, now(), savedWaveSim, SheetInfo);
        const newLdc = patternInput[0];
        let newState;
        const tupledArg = newCS;
        newState = [map_1((comp) => {
            const matchValue_2 = tryFind((c) => equals(c.Id, comp.Id), patternInput[1]);
            if (matchValue_2 != null) {
                const newRam = matchValue_2;
                dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* WriteMemoryType */ 31, [comp.Id, newRam.Type])])])]));
                return newRam;
            }
            else {
                return comp;
            }
        }, tupledArg[0]), tupledArg[1]];
        writeComponentToBackupFile(4, 1, newLdc, dispatch);
        return [newLdc, newState];
    }
    else {
        return toFail(printf("No project"));
    }
}

/**
 * save current open Verilog file, updating model etc, and returning the loaded component and the saved (unreduced) canvas state
 */
export function updateVerilogFileActionWithModelUpdate(newCS_, newCS__1, name, model, dispatch) {
    let matchValue, p, option_1;
    const newCS = [newCS_, newCS__1];
    const model$0027 = new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, (matchValue = model.CurrentProj, (matchValue != null) ? ((p = matchValue, new Project(p.ProjectPath, p.OpenFileName, name, p.LoadedComponents))) : toFail(printf("What? Should never be able to save sheet when project=None"))), model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState);
    const opt = updateVerilogFileAction(newCS[0], newCS[1], name, model$0027, dispatch);
    let ldcOpt;
    const option = opt;
    ldcOpt = ((option != null) ? option[0] : undefined);
    defaultArg((option_1 = opt, (option_1 != null) ? option_1[1] : undefined), [empty(), empty()]);
    const matchValue_1 = model$0027.CurrentProj;
    if (matchValue_1 != null) {
        const p_1 = matchValue_1;
        dispatch(new Msg(/* SetProject */ 39, [new Project(p_1.ProjectPath, p_1.OpenFileName, p_1.WorkingFileName, updateLdCompsWithCompOpt(ldcOpt, p_1.LoadedComponents))]));
    }
    else {
        toFail(printf("What? Should never be able to save sheet when project=None"));
    }
    let p$0027$0027;
    const matchValue_2 = model$0027.CurrentProj;
    if (matchValue_2 != null) {
        const p_2 = matchValue_2;
        p$0027$0027 = (new Project(p_2.ProjectPath, p_2.OpenFileName, p_2.WorkingFileName, updateLdCompsWithCompOpt(ldcOpt, p_2.LoadedComponents)));
    }
    else {
        p$0027$0027 = toFail(printf("What? Should never be able to save sheet when project=None"));
    }
    dispatch(new Msg(/* JSDiagramMsg */ 8, [new JSDiagramMsg(/* SetHasUnsavedChanges */ 4, [false])]));
    dispatch(Msg.FinishUICmd);
    return p$0027$0027;
}

export function createEmptyComponentAndFile(pPath, sheetName) {
    createEmptyDgmFile(pPath, sheetName);
    return new LoadedComponent(sheetName, now(), pathJoin([pPath, toText(printf("%s.dgm"))(sheetName)]), undefined, [empty(), empty()], empty(), empty(), undefined, CCForm.User, false, undefined, false, undefined);
}

/**
 * rename a sheet
 */
export function renameSheet(oldName, newName, model, dispatch) {
    let option, option_1;
    const matchValue = updateProjectFromCanvas(model, dispatch);
    if (matchValue != null) {
        const p = matchValue;
        const opt = saveOpenFileAction(false, new Model(model.WindowWidth, model.KeyFocusPane, model.RunAfterRenderWithSpinner, model.UserData, model.WaveSim, model.WaveSimSheet, model.UISheetTrail, model.Spinner, model.Sheet, model.IsLoading, model.LastChangeCheckTime, model.LastSimulatedCanvasState, model.LastDetailedSavedState, model.CurrentSelected, model.LastSelectedIds, model.LastUsedDialogWidth, model.SelectedComponent, model.CurrentStepSimulationStep, model.CurrentTruthTable, model.TTConfig, model.RightPaneTabVisible, model.SimSubTabVisible, model.CircuitCheck, model.Hilighted, model.Clipboard, model.LastCreatedComponent, model.SavedSheetIsOutOfDate, model.PendingDragAddition, model.DragPlacement, model.ProjectBrowser, model.TopSheetChoiceDeclined, model.ComponentLibraries, model.OpenLibrary, model.CatalogueSearch, model.ArrayCopiesTyped, model.SimulateInRenderer, model.SidecarSession, model.ProbeRead, model.SidecarInFlight, model.SidecarBuildEndedMs, model.SidecarRunEndedMs, model.StepRunTarget, model.FetchedData, model.FetchedStructure, model.FailedFetch, model.StimulusGeneration, model.CurrentViewport, model.ViewportChangedAtMs, model.WaveScrollSettling, model.WaveScrollSerial, model.ShowLibrarySheets, model.SuppressErrorPopups, model.OpenedLibrarySheets, model.ReadOnlyBaseline, p, model.PopupViewFunc, model.SpinnerPayload, model.PopupDialogData, model.Notifications, model.TopMenuOpenState, model.SheetMenuPinned, model.DividerDragMode, model.WaveSimViewerWidth, model.ConnsOfSelectedWavesAreHighlighted, model.Pending, model.UIState, model.BuildVisible, model.CodeEditorState), dispatch);
        updateLdCompsWithCompOpt((option = opt, (option != null) ? option[0] : undefined), p.LoadedComponents);
        defaultArg((option_1 = opt, (option_1 != null) ? option_1[1] : undefined), [empty(), empty()]);
        iterate((extn) => {
            displayAlertOnError(dispatch, renameFile(extn, p.ProjectPath, oldName, newName));
        }, singleton(".dgm"));
        let proj$0027;
        const oldName_2 = oldName;
        const newName_3 = newName;
        const proj = p;
        proj$0027 = (new Project(proj.ProjectPath, (proj.OpenFileName === oldName_2) ? newName_3 : proj.OpenFileName, (proj.OpenFileName === oldName_2) ? newName_3 : proj.WorkingFileName, map_1((ldComp_1) => {
            if (ldComp_1.Name === oldName_2) {
                return new LoadedComponent(newName_3, ldComp_1.TimeStamp, pathJoin([dirName(ldComp_1.FilePath), newName_3 + ".dgm"]), ldComp_1.WaveInfo, ldComp_1.CanvasState, ldComp_1.InputLabels, ldComp_1.OutputLabels, ldComp_1.LCParameterSlots, ldComp_1.Form, ldComp_1.LoadedComponentIsOutOfDate, ldComp_1.Description, ldComp_1.IsTopSheet, ldComp_1.ArrayInfo);
            }
            else {
                const ldComp = ldComp_1;
                const state = ldComp.CanvasState;
                return new LoadedComponent(ldComp.Name, ldComp.TimeStamp, ldComp.FilePath, ldComp.WaveInfo, [map_1((comp) => {
                    let matchResult, compName_1, customType_1, c;
                    if (comp.Type.tag === 26) {
                        if (comp.Type.fields[0].Name === oldName) {
                            matchResult = 0;
                            compName_1 = comp.Type.fields[0].Name;
                            customType_1 = comp.Type.fields[0];
                        }
                        else {
                            matchResult = 1;
                            c = comp;
                        }
                    }
                    else {
                        matchResult = 1;
                        c = comp;
                    }
                    switch (matchResult) {
                        case 0:
                            return new Component(comp.Id, new ComponentType(/* Custom */ 26, [new CustomComponentType(newName_3, customType_1.InputLabels, customType_1.OutputLabels, customType_1.Form, customType_1.ParameterBindings, customType_1.Description)]), comp.Label, comp.InputPorts, comp.OutputPorts, comp.X, comp.Y, comp.H, comp.W, comp.SymbolInfo, comp.SlotInfo);
                        default:
                            return c;
                    }
                }, state[0]), state[1]], ldComp.InputLabels, ldComp.OutputLabels, ldComp.LCParameterSlots, ldComp.Form, ldComp.LoadedComponentIsOutOfDate, ldComp.Description, ldComp.IsTopSheet, ldComp.ArrayInfo);
            }
        }, proj.LoadedComponents)));
        setupProjectFromComponents(false, proj$0027.OpenFileName, proj$0027.LoadedComponents, model, dispatch);
        writeAllSheetFiles(proj$0027);
        dispatch(Msg.FinishUICmd);
    }
    else {
        toFail(printf("What? current project cannot be None at this point in renamesheet"));
    }
}

/**
 * rename file
 */
export function renameFileInProject(name, project, model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project_1 = matchValue;
        dialogPopup("Rename sheet in project", (model_1) => dialogPopupBodyOnlyText((dialogData) => {
            let s_2;
            const dialogText = getText(dialogData);
            const children_2 = ["Warning: the current sheet will be saved during this operation.", react.createElement("br", {}), (s_2 = "Names of existing components in other sheets that use the renamed sheet will still reflect the old sheet name.", s_2), " You may change names manually if you wish, operation does not depend on the name.", react.createElement("br", {}), react.createElement("br", {}), toText(printf("Sheet %s will be renamed as %s:"))(name)(dialogText), react.createElement("br", {}), react.createElement("br", {}), defaultArg(maybeWarning(dialogText, project_1), react.createElement("div", {}))];
            return react.createElement("div", {}, ...children_2);
        }, "New name for design sheet", dispatch, model_1), "Rename", (model_2) => {
            const newName = getText(model_2.PopupDialogData).toLocaleLowerCase();
            dispatch(new Msg(/* ExecFuncInMessage */ 116, [(model_3, dispatch_1) => {
                renameSheet(name, newName, model_3, dispatch_1);
            }, dispatch]));
            dispatch(Msg.ClosePopup);
        }, (model_4) => {
            const dialogText_1 = getText(model_4.PopupDialogData);
            if (isFileInProject(dialogText_1, project_1)) {
                return true;
            }
            else {
                return dialogText_1 === "";
            }
        }, empty(), dispatch);
    }
    else {
        warn_1("renameFileInProject called when no project is currently open");
    }
}

/**
 * Create a new file in this project and open it automatically.
 */
export function addFileToProject(model, dispatch) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        dialogPopup("Add sheet to project", (model_1) => dialogPopupBodyOnlyText((dialogData) => {
            const dialogText = getText(dialogData);
            const warn = maybeWarning(dialogText, project);
            const children_2 = ["A new sheet will be created at:", react.createElement("br", {}), pathJoin([project.ProjectPath, dialogText + ".dgm"]), defaultArg(warn, react.createElement("div", {}))];
            return react.createElement("div", {}, ...children_2);
        }, "Insert design sheet name", dispatch, model_1), "Add", (model$0027) => {
            const name = getText(model$0027.PopupDialogData).toLocaleLowerCase();
            displayAlertOnError(dispatch, createEmptySheetFile(project, name));
            openFileInProject$0027(true, name, new Project(project.ProjectPath, name, name, cons(new LoadedComponent(name, now(), sheetFilePath(project, name), undefined, [empty(), empty()], empty(), empty(), undefined, CCForm.User, false, undefined, false, undefined), project.LoadedComponents)), model, dispatch);
            dispatch(Msg.ClosePopup);
            dispatch(Msg.FinishUICmd);
        }, (model$0027_1) => {
            const dialogText_1 = getText(model$0027_1.PopupDialogData);
            if (isFileInProject(dialogText_1, project) ? true : (dialogText_1 === "")) {
                return true;
            }
            else {
                return !equals(maybeWarning(dialogText_1, project), undefined);
            }
        }, empty(), dispatch);
    }
    else {
        warn_1("addFileToProject called when no project is currently open");
    }
}

function loadDemoProjectWithInitRamOverride(model, dispatch, basename, initRamOverride, notice) {
    warnAppWidth(dispatch, () => {
        const sourceDir = pathJoin([staticDir(), "demos", basename]);
        const matchValue = Result_Bind((d) => tryEnsureDirectory(pathJoin([d, basename])), tryUserDemosDirectory());
        if (matchValue.tag === 0) {
            const newDir = matchValue.fields[0];
            dbg(128, concat("loading demo ", sourceDir, " into ", newDir));
            iterate((path) => {
                unlink(pathJoin([newDir, path]));
            }, readFilesFromDirectory(newDir));
            const openLoadedDemo = () => {
                const option_1 = initRamOverride;
                if (option_1 != null) {
                    const ramText = option_1;
                    displayAlertOnError(dispatch, writeFile(pathJoin([newDir, "init.ram"]), ramText));
                }
                const option_3 = notice;
                if (option_3 != null) {
                    showHashNotice(dispatch, option_3);
                }
                openDemoProjectFromPath(newDir, model, dispatch);
            };
            clearBrowserStoredPath(newDir);
            mkdir(newDir);
            dispatch(Msg.EndSimulation);
            dispatch(new Msg(/* TruthTableMsg */ 32, [TTMsg.CloseTruthTable]));
            dispatch(Msg.EndWaveSim);
            const openCopiedDemo = () => {
                iterate((basename_1) => {
                    const newPath = pathJoin([newDir, basename_1]);
                    copyFile(pathJoin([sourceDir, basename_1]), newPath);
                }, filter((path_1) => {
                    if (hasExtn(".dgm", path_1) ? true : hasExtn(".txt", path_1)) {
                        return true;
                    }
                    else {
                        return hasExtn(".ram", path_1);
                    }
                }, readFilesFromDirectory(sourceDir)));
                openLoadedDemo();
            };
            const pr = loadBundledDemoAsync(sourceDir, newDir);
            void (pr.then((loadedFromBundle) => {
                if (loadedFromBundle) {
                    openLoadedDemo();
                }
                else {
                    openCopiedDemo();
                }
            }).catch((_arg_1) => {
                openCopiedDemo();
            }));
        }
        else {
            displayFileErrorNotification(concat("The demo could not be opened: ", matchValue.fields[0]), dispatch);
        }
    });
}

export function loadDemoProject(model, dispatch, basename) {
    loadDemoProjectWithInitRamOverride(model, dispatch, basename, undefined, undefined);
}

export function loadDemoProjectFromHash(model, dispatch) {
    const matchValue_1 = tryParseHashDemoRequest();
    let matchResult;
    if (model.CurrentProj == null) {
        switch (matchValue_1.tag) {
            case 2: {
                matchResult = 0;
                break;
            }
            case 1: {
                matchResult = 1;
                break;
            }
            default:
                matchResult = 2;
        }
    }
    else {
        matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            const request = matchValue_1.fields[0];
            loadDemoProjectWithInitRamOverride(model, dispatch, request.DemoBasename, request.InitRamOverride, request.Notice);
            break;
        }
        case 1: {
            showHashNotice(dispatch, matchValue_1.fields[0]);
            break;
        }
        case 2: {
            break;
        }
    }
}

/**
 * show menu for choosing demo project
 */
export function showDemoProjects(model, dispatch, demosInfo) {
    const matchValue = model.CurrentProj;
    if (matchValue == null) {
        dynamicClosablePopup("Choose Demo Project", (model$0027_1) => {
            let props_22;
            const children_22 = [(props_22 = [["style", {
                fontWeight: "bold",
            }]], react.createElement("p", keyValueList(props_22, 1), "Note: Reloading the demo deletes all changes made to it.")), react.createElement("br", {}), menu(empty(), singleton(list_3(empty(), isEmpty(demosInfo) ? singleton(react.createElement("div", {}, "The directory that is supposed to contain the demos doesn\'t exist!")) : map_1((tupledArg) => {
                let children_16;
                const path = tupledArg[0];
                let basename_1;
                const basename = path;
                const basenameL = StringModule_Length(basename) | 0;
                basename_1 = basename.slice(1, (basenameL - 1) + 1);
                return Item_li(ofArray([new Item_Option(/* IsActive */ 0, [false]), new Item_Option(/* OnClick */ 3, [(_arg) => {
                    loadDemoProject(model, dispatch, path);
                }])]), singleton((children_16 = toList(delay(() => {
                    let props;
                    return append(singleton_1((props = [["style", {
                        fontWeight: "bold",
                    }]], react.createElement("p", keyValueList(props, 1), basename_1))), delay(() => append(singleton_1(react.createElement("br", {})), delay(() => {
                        const matchValue_1 = basename_1;
                        return (matchValue_1 === "cpu") ? singleton_1(react.createElement("div", {}, "The EEP1 CPU architecture designed in Year 1 labs")) : ((matchValue_1 === "fulladder") ? singleton_1(react.createElement("div", {}, "Full adder circuit built from 2 half adders")) : ((matchValue_1 === "registerFile") ? singleton_1(react.createElement("div", {}, "regx16x8 file from EEP1 demo using net labels to simplify wiring")) : ((matchValue_1 === "adder (4-bit)") ? singleton_1(react.createElement("div", {}, "Cascading 1-bit full adders to create 4-bit adder")) : ((matchValue_1 === "eratosthenes") ? singleton_1(react.createElement("div", {}, "The EEP1 CPU running a program to calculate prime numbers")) : ((matchValue_1 === "pipeline") ? singleton_1(react.createElement("div", {}, "The EEP1 CPU with pipeline designed in Year 1 labs")) : ((matchValue_1 === "interupt") ? singleton_1(react.createElement("div", {}, "The EEP1 CPU with interupt designed in Year 1 labs")) : singleton_1("Information about other design")))))));
                    }))));
                })), react.createElement("div", {}, ...children_16))));
            }, demosInfo))))];
            return react.createElement("div", {}, ...children_22);
        }, (model$0027_2) => react.createElement("div", {}), empty(), dispatch);
    }
}

/**
 * Display the initial Open/Create Project menu at the beginning if no project
 * is open.
 */
export function viewNoProjectMenu(model, dispatch) {
    const menuItem = (label, action) => Item_li(ofArray([new Item_Option(/* IsActive */ 0, [false]), new Item_Option(/* OnClick */ 3, [action])]), singleton(label));
    const demosInfo = map_1((basename) => [basename, 0, 0], readFilesFromDirectory(staticDir() + "/demos"));
    const recentsList = map_1((path) => recentProjectItem(path, cropToLength(Constants_maxDisplayedPathLengthInRecentProjects, false, path), (path_1) => {
        openProjectFromPath(path_1, model, dispatch);
    }, model, dispatch), recentProjects(model));
    const helpItem = Item_li(ofArray([new Item_Option(/* IsActive */ 0, [false]), new Item_Option(/* OnClick */ 3, [(_arg) => {
        viewInfoPopupAtTab(0, dispatch);
    }])]), singleton("New to Issie? Start here"));
    const initialMenu = menu(empty(), singleton(list_3(empty(), append_1(ofArray([menuItem("New project", (_arg_1) => {
        dispatch(new Msg(/* FileCommand */ 111, [new FileCommandType(/* FileNewProject */ 1, [false]), dispatch]));
    }), menuItem("Open project", (_arg_2) => {
        dispatch(new Msg(/* FileCommand */ 111, [new FileCommandType(/* FileOpenProject */ 2, [false]), dispatch]));
    }), menuItem("Open demo project", (_arg_3) => {
        dispatch(new Msg(/* FileCommand */ 111, [new FileCommandType(/* FileShowDemos */ 6, [demosInfo]), dispatch]));
    })]), append_1(!equals(recentsList, empty()) ? singleton(react.createElement("hr", {})) : empty(), append_1(recentsList, ofArray([react.createElement("hr", {}), helpItem])))))));
    if (model.CurrentProj == null) {
        return unclosablePopup(undefined, initialMenu, undefined, empty(), dispatch);
    }
    else {
        return react.createElement("div", {});
    }
}

export function goBackToProject(model, dispatch, _arg) {
    return dispatch(new Msg(/* SetExitDialog */ 106, [false]));
}

export function closeApp(model, dispatch, _arg) {
    return dispatch(Msg.CloseApp);
}

/**
 * Display top menu.
 */
export function getInfoButton(name, project) {
    const matchValue = find((ldc) => (ldc.Name === name), project.LoadedComponents).Description;
    if (matchValue == null) {
        return defaultOf();
    }
    else {
        const props = [new HTMLAttr(/* ClassName */ 64, [`${"tooltip"} ${"has-tooltip-multiline"} ${"has-tooltip-info"} ${"has-tooltip-right"}`]), dataTooltip(matchValue), ["style", {
            fontSize: "20px",
            marginTop: "0px",
            marginRight: "10px",
            float: "left",
        }]];
        return react.createElement("div", keyValueList(props, 1), "🛈");
    }
}

export class LockState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Locked", "Unlocked"];
    }
    static Locked = new LockState(0, []);
    static Unlocked = new LockState(1, []);
}

export function LockState_$reflection() {
    return union_type("TopMenuView.LockState", [], LockState, () => [[], []]);
}

export function invertSheetLockState(_arg) {
    if (_arg.tag === 1) {
        return LockState.Locked;
    }
    else {
        return LockState.Unlocked;
    }
}

export function sheetIsLocked(sheet, model) {
    const project = value_6(model.CurrentProj);
    const matchValue = defaultArg(tryFind((ldc) => (ldc.Name === sheet), project.LoadedComponents), find((ldc_1) => (ldc_1.Name === project.OpenFileName), project.LoadedComponents)).Form;
    let matchResult;
    if (matchValue != null) {
        switch (matchValue.tag) {
            case 2:
            case 3: {
                matchResult = 0;
                break;
            }
            default:
                matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return true;
        default:
            return false;
    }
}

/**
 * Change model to alter lock of sheet as determined by updateLock.
 * Unlockable sheets are kept the same.
 * isSubSheet must be true only if sheet is a root of the design hierarchy.
 */
export function changeLockState(isSubSheet, sheet, updateLock) {
    let p_2, p_6;
    let f1_1;
    const f1 = Optic_Map_op_HatPercent_Z32F545AB(Optic_Map.Map$, (p_2 = Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, loadedComponentOf_(sheet.SheetName))(projectOpt_), Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, formOpt_)(p_2)))((option_1) => {
        let form, matchValue, option, _arg;
        const option_2 = option_1;
        if (option_2 != null) {
            return (form = option_2, (matchValue = ((option = ((_arg = form, (_arg.tag === 2) ? LockState.Locked : ((_arg.tag === 3) ? LockState.Locked : ((_arg.tag === 0) ? LockState.Unlocked : undefined)))), (option != null) ? updateLock(option) : undefined)), (matchValue == null) ? form : ((matchValue.tag === 0) ? (isSubSheet ? CCForm.ProtectedSubSheet : CCForm.ProtectedTopLevel) : CCForm.User)));
        }
        else {
            return undefined;
        }
    });
    const f2 = Optic_Set_op_HatEquals_Z32E30375(Optic_Set.Set$, (p_6 = Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, loadedComponentOf_(sheet.SheetName))(projectOpt_), Compose_Prism_op_GreaterQmarkGreater_507FA136(Compose_Prism.Prism, loadedComponentIsOutOfDate_)(p_6)))(true);
    f1_1 = ((arg_7) => f2(f1(arg_7)));
    const f2_1 = Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, savedSheetIsOutOfDate_)(true);
    return (arg_9) => f2_1(f1_1(arg_9));
}

/**
 * Change model to alter lock of tree with root sheet as determined by updateLock.
 * Unlockable sheets are kept the same.
 * isSubSheet must be true only if sheet is a root of the design hierarchy.
 */
export function changeSubtreeLockState(isSubSheet, sheet, updateLock) {
    return (model) => foldOverTree(isSubSheet, uncurry3((b) => ((sheet_1) => changeLockState(b, sheet_1, updateLock))), sheet, model);
}

export function addVerticalScrollBars(el, r) {
    let props;
    if (el != null) {
        const el_1 = el;
        return singleton((props = [["style", {
            maxHeight: el_1.offsetHeight - 50,
            maxWidth: el_1.offsetWidth - 50,
            overflowY: "auto",
            overflowX: "auto",
        }]], react.createElement("div", keyValueList(props, 1), ...r)));
    }
    else {
        return r;
    }
}

const isMacPlatform = isMac;

function itemWithKeyIf(enabled, label, id, action) {
    let props, children;
    return Item_a(singleton(new Item_Option_1(/* Props */ 5, [toList(delay(() => append(enabled ? singleton_1(new DOMAttr(/* OnClick */ 40, [(_arg) => {
        action();
    }])) : empty_1(), delay(() => singleton_1(["style", keyValueList(toList(delay(() => append(singleton_1(new CSSProp(/* Display */ 125, ["flex"])), delay(() => append(singleton_1(new CSSProp(/* JustifyContent */ 200, ["space-between"])), delay(() => append(!enabled ? singleton_1(new CSSProp(/* Opacity */ 261, ["0.4"])) : empty_1(), delay(() => (!enabled ? singleton_1(new CSSProp(/* Cursor */ 123, ["default"])) : empty_1()))))))))), 1)])))))])), ofArray([label, (props = [["style", {
        marginLeft: "2.5em",
        opacity: "0.5",
        fontSize: "90%",
        whiteSpace: "nowrap",
    }]], (children = [idLabel(isMacPlatform, id)], react.createElement("span", keyValueList(props, 1), ...children)))]));
}

function itemWithKey(label, id, action) {
    return itemWithKeyIf(true, label, id, action);
}

function itemIf(enabled, label, action) {
    return Item_a(singleton(new Item_Option_1(/* Props */ 5, [toList(delay(() => append(enabled ? singleton_1(new DOMAttr(/* OnClick */ 40, [(_arg) => {
        action();
    }])) : empty_1(), delay(() => singleton_1(["style", keyValueList(toList(delay(() => append(singleton_1(new CSSProp(/* Display */ 125, ["flex"])), delay(() => append(singleton_1(new CSSProp(/* JustifyContent */ 200, ["space-between"])), delay(() => append(!enabled ? singleton_1(new CSSProp(/* Opacity */ 261, ["0.4"])) : empty_1(), delay(() => (!enabled ? singleton_1(new CSSProp(/* Cursor */ 123, ["default"])) : empty_1()))))))))), 1)])))))])), singleton(label));
}

function itemGroupHeading(label) {
    return Item_div(singleton(new Item_Option_1(/* Props */ 5, [singleton(["style", {
        fontSize: "85%",
        opacity: "0.55",
        paddingBottom: "0",
        cursor: "default",
    }])])), singleton(label));
}

function dropdown(isOpen, items) {
    return Dropdown_div(singleton(new Dropdown_Option(/* Props */ 3, [singleton(["style", {
        display: isOpen ? "block" : "none",
    }])])), items);
}

function topMenuEntry(name, thisMenu, openState, dispatch, items) {
    return Item_div(ofArray([Item_Option_1.HasDropdown, new Item_Option_1(/* Props */ 5, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg) => {
        dispatch(new Msg(/* SetTopMenu */ 85, [equals(openState, thisMenu) ? TopMenu.Closed : thisMenu]));
    }]))])]), ofArray([Link_a(empty(), singleton(name)), dropdown(equals(openState, thisMenu), items)]));
}

function editMenuItems(model, dispatch) {
    const sheetDispatch = (sMsg) => {
        dispatch(new Msg(/* Sheet */ 3, [sMsg]));
    };
    const keyDispatch = (arg) => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [arg]));
    };
    let editItem;
    const enabled = !openSheetIsReadOnly(model);
    editItem = ((label) => ((id) => ((action) => itemWithKeyIf(enabled, label, id, action))));
    return ofArray([editItem("Undo")(ShortcutId.ScUndo)(() => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlZ);
    }), editItem("Redo")(ShortcutId.ScRedo)(() => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlY);
    }), divider(empty(), empty()), itemWithKey("Select all", ShortcutId.ScSelectAll, () => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlA);
    }), editItem("Copy")(ShortcutId.ScCopy)(() => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlC);
    }), editItem("Paste")(ShortcutId.ScPaste)(() => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlV);
    }), itemIf(!openSheetIsReadOnly(model) && (PasteArray_arrayChoices(model) != null), "Paste array...", () => {
        PasteArray_pasteArrayPopup(model, dispatch);
    }), editItem("Delete")(ShortcutId.ScDelete)(() => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.DEL);
    }), divider(empty(), empty()), editItem("Rotate clockwise")(ShortcutId.ScRotateClockwise)(() => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Rotate */ 34, [Rotation.Degree90]));
    }), editItem("Rotate anticlockwise")(ShortcutId.ScRotateAnticlockwise)(() => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Rotate */ 34, [Rotation.Degree270]));
    }), editItem("Flip vertically")(ShortcutId.ScFlipVertical)(() => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Flip */ 35, ["flipVertical"]));
    }), editItem("Flip horizontally")(ShortcutId.ScFlipHorizontal)(() => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Flip */ 35, ["flipHorizontal"]));
    }), editItem("Align")(ShortcutId.ScAlign)(() => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Arrangement */ 36, [DrawModelType_SheetT_Arrange.AlignSymbols]));
    }), editItem("Distribute")(ShortcutId.ScDistribute)(() => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Arrangement */ 36, [DrawModelType_SheetT_Arrange.DistributeSymbols]));
    }), editItem("Rotate label")(ShortcutId.ScRotateLabel)(() => {
        sheetDispatch(DrawModelType_SheetT_Msg.RotateLabels);
    }), divider(empty(), empty()), editItem("Redraw floating wires")(ShortcutId.ScRedrawFloatingWires)(() => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* RedrawWires */ 39, [false]));
    }), editItem("Redraw all wires")(ShortcutId.ScRedrawAllWires)(() => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* RedrawWires */ 39, [true]));
    }), editItem("Separate manual routing")(ShortcutId.ScSeparateManualRouting)(() => {
        sheetDispatch(DrawModelType_SheetT_Msg.SeparateManualRouting);
    }), divider(empty(), empty()), itemWithKey("How to move component ports", ShortcutId.ScMovePortsHelp, () => {
        dispatch(new Msg(/* ShowStaticInfoPopup */ 50, [["How to move component ports", moveCustomPortsPopup(), dispatch]]));
    })]);
}

function viewMenuItems(dispatch) {
    const sheetDispatch = (sMsg) => {
        dispatch(new Msg(/* Sheet */ 3, [sMsg]));
    };
    const keyDispatch = (arg) => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [arg]));
    };
    const busWireDispatch = (bMsg) => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [bMsg]));
    };
    const setTheme = (theme) => {
        dispatch(new Msg(/* SetThemeUserData */ 114, [theme]));
        busWireDispatch(new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* SetTheme */ 43, [theme])]));
    };
    const stepAppZoom = (delta) => {
        window.issieBridge.window.setZoomLevel(max(-9, min(9, (window.issieBridge.window.getZoomLevel()) + delta)));
    };
    return ofArray([itemWithKey("Enter/exit fullscreen", ShortcutId.ScFullScreen, () => {
        window.issieBridge.window.toggleFullScreen();
    }), divider(empty(), empty()), itemWithKey("Zoom application in", ShortcutId.ScAppZoomIn, () => {
        stepAppZoom(0.5);
    }), itemWithKey("Zoom application out", ShortcutId.ScAppZoomOut, () => {
        stepAppZoom(-0.5);
    }), itemWithKey("Zoom application reset", ShortcutId.ScAppZoomReset, () => {
        window.issieBridge.window.setZoomLevel(0);
    }), divider(empty(), empty()), itemWithKey("Zoom diagram in", ShortcutId.ScZoomIn, () => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.ZoomIn);
    }), itemWithKey("Zoom diagram out", ShortcutId.ScZoomOut, () => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.ZoomOut);
    }), itemWithKey("Zoom diagram to fit", ShortcutId.ScZoomToFit, () => {
        keyDispatch(DrawModelType_SheetT_KeyboardMsg.CtrlW);
    }), divider(empty(), empty()), itemWithKey("Show/hide grid", ShortcutId.ScToggleGrid, () => {
        sheetDispatch(DrawModelType_SheetT_Msg.ToggleGrid);
    }), itemWithKey("Show/hide wire arrows", ShortcutId.ScToggleWireArrows, () => {
        busWireDispatch(DrawModelType_BusWireT_Msg.ToggleArrowDisplay);
    }), divider(empty(), empty()), itemGroupHeading("Wire style"), itemWithKey("Jump", ShortcutId.ScWireTypeJump, () => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* WireType */ 41, [DrawModelType_SheetT_WireTypeMsg.Jump]));
    }), itemWithKey("Radiussed", ShortcutId.ScWireTypeRadiussed, () => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* WireType */ 41, [DrawModelType_SheetT_WireTypeMsg.Radiussed]));
    }), itemWithKey("Modern", ShortcutId.ScWireTypeModern, () => {
        sheetDispatch(new DrawModelType_SheetT_Msg(/* WireType */ 41, [DrawModelType_SheetT_WireTypeMsg.Modern]));
    }), divider(empty(), empty()), itemGroupHeading("Theme"), itemWithKey("Colourful", ShortcutId.ScThemeDefault, () => {
        setTheme(DrawModelType_SymbolT_ThemeType.Colourful);
    }), itemWithKey("Light", ShortcutId.ScThemeLight, () => {
        setTheme(DrawModelType_SymbolT_ThemeType.Light);
    }), itemWithKey("Grayscale", ShortcutId.ScThemeGrayscale, () => {
        setTheme(DrawModelType_SymbolT_ThemeType.White);
    }), divider(empty(), empty()), itemWithKey("Show/hide build tab", ShortcutId.ScToggleBuildTab, () => {
        dispatch(Msg.ChangeBuildTabVisibility);
    })]);
}

export function viewTopMenu(model, dispatch) {
    getComponentIds(model);
    const el = document.getElementById("Canvas");
    let numPathChars;
    if (el != null) {
        const el_1 = el;
        numPathChars = ((el_1.offsetWidth > Constants_largeScreenCanvasWidth) ? Constants_maxNumPathChars : Constants_minNumPathChars);
    }
    else {
        numPathChars = Constants_maxNumPathChars;
    }
    ["style", {
        width: "100%",
        borderBottom: "2px solid lightgray",
    }];
    ["style", {
        width: "100%",
    }];
    let patternInput;
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const project = matchValue;
        patternInput = [project.ProjectPath, project.OpenFileName];
    }
    else {
        patternInput = ["no open project", "no open sheet"];
    }
    const projectPath = patternInput[0];
    const fileName = patternInput[1];
    const props_14 = [new HTMLAttr(/* Id */ 99, ["TopMenu"]), leftSectionWidth(model), ["style", {
        position: "absolute",
        userSelect: "none",
    }]];
    const children_14 = [navbar(singleton(new Option_2(/* Props */ 6, [singleton(["style", {
        height: "100%",
        width: "100%",
    }])])), singleton(Brand_div(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
        height: "100%",
        width: "100%",
    }])])), toList(delay(() => {
        const topMenuOpenState_1 = model.TopMenuOpenState;
        return append(singleton_1(Item_div(ofArray([Item_Option_1.HasDropdown, new Item_Option_1(/* Props */ 5, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg_3) => {
            dispatch(new Msg(/* SetTopMenu */ 85, [equals(topMenuOpenState_1, TopMenu.Project) ? TopMenu.Closed : TopMenu.Project]));
        }]))])]), ofArray([Link_a(empty(), singleton("Project")), Dropdown_div(singleton(new Dropdown_Option(/* Props */ 3, [singleton(["style", {
            display: equals(topMenuOpenState_1, TopMenu.Project) ? "block" : "none",
        }])])), ofArray([Item_a(singleton(new Item_Option_1(/* Props */ 5, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg_4) => {
            dispatch(new Msg(/* FileCommand */ 111, [new FileCommandType(/* FileNewProject */ 1, [true]), dispatch]));
        }]))])), singleton("New project")), Item_a(singleton(new Item_Option_1(/* Props */ 5, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg_5) => {
            dispatch(new Msg(/* FileCommand */ 111, [new FileCommandType(/* FileOpenProject */ 2, [true]), dispatch]));
        }]))])), singleton("Open project")), Item_a(singleton(new Item_Option_1(/* Props */ 5, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg_6) => {
            dispatch(new Msg(/* FileCommand */ 111, [FileCommandType.FileCloseProject, dispatch]));
        }]))])), singleton("Close project")), divider(empty(), empty()), itemWithKey("Exit Issie", ShortcutId.ScQuit, () => {
            dispatch(new Msg(/* MenuAction */ 100, [MenuCommand.MenuExit, dispatch]));
        })]))]))), delay(() => {
            let model_1, matchValue_1, project_1, updatedProject, updatedModel, sTrees, topSheet, sheetsUnderTop, namesIn, option_3, option_1, isViewedLibrarySheet, breadcrumbConfig, topMenuOpenState, isPinned, refit, pin, props, children, breadcrumbs, children_4, props_2;
            return append(singleton_1((model_1 = model, (matchValue_1 = model_1.CurrentProj, (matchValue_1 != null) ? ((project_1 = matchValue_1, (updatedProject = getUpdatedLoadedComponents(project_1, model_1), (updatedModel = (new Model(model_1.WindowWidth, model_1.KeyFocusPane, model_1.RunAfterRenderWithSpinner, model_1.UserData, model_1.WaveSim, model_1.WaveSimSheet, model_1.UISheetTrail, model_1.Spinner, model_1.Sheet, model_1.IsLoading, model_1.LastChangeCheckTime, model_1.LastSimulatedCanvasState, model_1.LastDetailedSavedState, model_1.CurrentSelected, model_1.LastSelectedIds, model_1.LastUsedDialogWidth, model_1.SelectedComponent, model_1.CurrentStepSimulationStep, model_1.CurrentTruthTable, model_1.TTConfig, model_1.RightPaneTabVisible, model_1.SimSubTabVisible, model_1.CircuitCheck, model_1.Hilighted, model_1.Clipboard, model_1.LastCreatedComponent, model_1.SavedSheetIsOutOfDate, model_1.PendingDragAddition, model_1.DragPlacement, model_1.ProjectBrowser, model_1.TopSheetChoiceDeclined, model_1.ComponentLibraries, model_1.OpenLibrary, model_1.CatalogueSearch, model_1.ArrayCopiesTyped, model_1.SimulateInRenderer, model_1.SidecarSession, model_1.ProbeRead, model_1.SidecarInFlight, model_1.SidecarBuildEndedMs, model_1.SidecarRunEndedMs, model_1.StepRunTarget, model_1.FetchedData, model_1.FetchedStructure, model_1.FailedFetch, model_1.StimulusGeneration, model_1.CurrentViewport, model_1.ViewportChangedAtMs, model_1.WaveScrollSettling, model_1.WaveScrollSerial, model_1.ShowLibrarySheets, model_1.SuppressErrorPopups, model_1.OpenedLibrarySheets, model_1.ReadOnlyBaseline, updatedProject, model_1.PopupViewFunc, model_1.SpinnerPayload, model_1.PopupDialogData, model_1.Notifications, model_1.TopMenuOpenState, model_1.SheetMenuPinned, model_1.DividerDragMode, model_1.WaveSimViewerWidth, model_1.ConnsOfSelectedWavesAreHighlighted, model_1.Pending, model_1.UIState, model_1.BuildVisible, model_1.CodeEditorState)), (sTrees = getSheetTreesFiltered((sheet) => librarySheetsShown(model_1, sheet), false, updatedProject), (allRootSheets(sTrees), (topSheet = (projectHasAmbiguousDisplay(updatedProject.LoadedComponents) ? effectiveTopSheetFor(updatedProject.LoadedComponents, project_1.OpenFileName) : undefined), (sheetsUnderTop = ((namesIn = ((tree) => cons(tree.SheetName, collect(namesIn, tree.SubSheets))), defaultArg((option_3 = ((option_1 = topSheet, (option_1 != null) ? tryFind_1(option_1, sTrees) : undefined)), (option_3 != null) ? ofList(namesIn(option_3), {
                Compare: (x, y) => (comparePrimitives(x, y) | 0),
            }) : undefined), empty_2({
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            })))), (isViewedLibrarySheet = ((sheet_2) => contains(sheet_2.SheetName, model_1.OpenedLibrarySheets)), (breadcrumbConfig = (new BreadcrumbConfig(Constants_defaultConfig.AllowDuplicateSheets, (sheet_4) => librarySheetsShown(model_1, sheet_4), "SheetMenuBreadcrumb", (sheet_5) => {
                let option_8, option_6;
                const arrayMark = defaultArg((option_8 = ((option_6 = tryFind((lc) => (lc.Name === sheet_5.SheetName), updatedProject.LoadedComponents), (option_6 != null) ? option_6.ArrayInfo : undefined)), (option_8 != null) ? (` ×${copiesOfArray(option_8)}`) : undefined), "");
                return isViewedLibrarySheet(sheet_5) ? concat("👁 ", sheet_5.SheetName, arrayMark) : concat(sheet_5.SheetName, arrayMark);
            }, (sheet_3) => {
                const isTop = equals(topSheet, sheet_3.SheetName);
                const outsideTop = (topSheet != null) && !contains(sheet_3.SheetName, sheetsUnderTop);
                const matchValue_3 = sheet_3.SheetName === project_1.OpenFileName;
                const matchValue_4 = sheetIsLocked(sheet_3.SheetName, updatedModel);
                if (isViewedLibrarySheet(sheet_3)) {
                    return new Color_IColor(/* IsCustomColor */ 19, [(sheet_3.SheetName === project_1.OpenFileName) ? "mediumpurple" : "rebeccapurple"]);
                }
                else if (matchValue_3) {
                    if (matchValue_4) {
                        return new Color_IColor(/* IsCustomColor */ 19, ["pink"]);
                    }
                    else if (isTop) {
                        return Color_IColor.IsSuccess;
                    }
                    else {
                        return Color_IColor.IsInfo;
                    }
                }
                else if (matchValue_4) {
                    return Color_IColor.IsDanger;
                }
                else if (isTop) {
                    return new Color_IColor(/* IsCustomColor */ 19, ["darkgreen"]);
                }
                else if (outsideTop) {
                    return new Color_IColor(/* IsCustomColor */ 19, ["grey"]);
                }
                else {
                    return new Color_IColor(/* IsCustomColor */ 19, ["darkslategrey"]);
                }
            }, (sheet_1, dispatch_1) => {
                dispatch_1(new Msg(/* StartUICmd */ 109, [UICommandType.ChangeSheet]));
                dispatch_1(new Msg(/* ExecFuncInMessage */ 116, [(model_2, dispatch_2) => {
                    openFileInProject(sheet_1.SheetName, value_6(model_2.CurrentProj), model_2, dispatch_2);
                }, dispatch_1]));
            }, Constants_defaultConfig.ElementProps, Constants_defaultConfig.ElementStyleProps, Constants_defaultConfig.ButtonOptions, Constants_defaultConfig.NoWaves, Constants_defaultConfig.IsCollapsible, Constants_defaultConfig.ExpandAction)), (topMenuOpenState = model_1.TopMenuOpenState, (isPinned = model_1.SheetMenuPinned, (refit = (new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [DrawModelType_SheetT_KeyboardMsg.CtrlW])])), (pin = ((props = [new HTMLAttr(/* ClassName */ 64, [`${"tooltip"} ${"has-tooltip-right"} ${"has-tooltip-multiline"}`]), dataTooltip(isPinned ? "Unpin: the menu closes, and a sheet still sized to fit beside it goes back to filling the schematic." : "Pin the menu open, so that it stays while you open sheets and work on the schematic. Sheets are then sized to fit beside it."), ["style", {
                position: "absolute",
                left: "0",
                top: "0",
                cursor: "pointer",
            }], new DOMAttr(/* OnClick */ 40, [(ev) => {
                let option_11, option_14;
                ev.stopPropagation();
                const pinnedWindow = fitWindowFor(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, sheetMenuPinned_)(true)(model_1));
                if (isPinned) {
                    const wasFitted = defaultArg((option_11 = pinnedWindow, (option_11 != null) ? isAtFittedPosition(option_11, model_1.Sheet) : undefined), false);
                    dispatch(new Msg(/* SetSheetMenuPinned */ 86, [false]));
                    dispatch(new Msg(/* SetTopMenu */ 85, [TopMenu.Closed]));
                    if (wasFitted) {
                        dispatch(refit);
                    }
                }
                else {
                    const willShrink = defaultArg((option_14 = pinnedWindow, (option_14 != null) ? (option_14.Inset > 0) : undefined), false);
                    dispatch(new Msg(/* SetSheetMenuPinned */ 86, [true]));
                    if (willShrink) {
                        dispatch(refit);
                    }
                }
            }])], (children = [pinSvg(isPinned)], react.createElement("div", keyValueList(props, 1), ...children)))), (breadcrumbs = singleton((children_4 = [(props_2 = [["style", {
                textAlign: "center",
                fontSize: "15px",
                paddingBottom: "10px",
                position: "relative",
            }]], react.createElement("div", keyValueList(props_2, 1), pin, "Sheets with Hierarchy")), allRootHierarchiesFromProjectBreadcrumbs(breadcrumbConfig, dispatch, updatedModel)], react.createElement("div", {
                className: "treePanel",
            }, ...children_4))), Item_div(ofArray([Item_Option_1.HasDropdown, new Item_Option_1(/* Props */ 5, [singleton(["style", {
                position: "static",
            }])])]), ofArray([Link_a(singleton(new Link_Option(/* Props */ 2, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg) => {
                dispatch(new Msg(/* SetTopMenu */ 85, [equals(topMenuOpenState, TopMenu.Files) ? TopMenu.Closed : TopMenu.Files]));
            }]))])), singleton("Sheet")), Dropdown_div(singleton(new Dropdown_Option(/* Props */ 3, [ofArray([new HTMLAttr(/* Id */ 99, [Constants_sheetMenuId]), new DOMAttr(/* OnClick */ 40, [(_arg_1) => {
                if (!isPinned) {
                    dispatch(new Msg(/* SetTopMenu */ 85, [TopMenu.Closed]));
                }
            }]), ["style", {
                display: equals(topMenuOpenState, TopMenu.Files) ? "block" : "none",
                left: "0",
                minWidth: "0",
            }]])])), addVerticalScrollBars(el, append_1(ofArray([itemWithKey("New Sheet", ShortcutId.ScNewSheet, () => {
                dispatch(new Msg(/* StartUICmd */ 109, [UICommandType.AddSheet]));
                dispatch(new Msg(/* FileCommand */ 111, [FileCommandType.FileAddFile, dispatch]));
            }), divider(empty(), empty()), Item_a(singleton(new Item_Option_1(/* Props */ 5, [singleton(new DOMAttr(/* OnClick */ 40, [(_arg_2) => {
                dispatch(new Msg(/* StartUICmd */ 109, [UICommandType.ImportSheet]));
                dispatch(new Msg(/* FileCommand */ 111, [FileCommandType.FileImportSheet, dispatch]));
            }]))])), singleton("Import Sheet")), divider(empty(), empty())]), breadcrumbs)))]))))))))))))))))) : Item_div(empty(), empty())))), delay(() => append(singleton_1(topMenuEntry("Edit", TopMenu.Edit, topMenuOpenState_1, dispatch, editMenuItems(model, dispatch))), delay(() => append(singleton_1(topMenuEntry("View", TopMenu.View, topMenuOpenState_1, dispatch, viewMenuItems(dispatch))), delay(() => {
                let props_6, props_8, children_8;
                const hidePath = numPathChars < Constants_numCharsHidePath;
                const pathItem = item(singleton(new Item_Option_2(/* Props */ 1, [singleton(new HTMLAttr(/* Id */ 99, ["ProjectPath"]))])), singleton(hidePath ? "" : cropToLength(numPathChars, false, projectPath)));
                const nameItem = item(empty(), singleton((props_6 = [["style", {
                    fontWeight: "bold",
                }]], react.createElement("span", keyValueList(props_6, 1), fileName))));
                return append(singleton_1(Item_div(empty(), singleton((props_8 = [new HTMLAttr(/* ClassName */ 64, [`${"tooltip"} ${"has-tooltip-multiline"} ${"has-tooltip-bottom"}`]), dataTooltip(concat(projectPath, ":", fileName))], (children_8 = [breadcrumb(singleton(Option_3.HasArrowSeparator), hidePath ? singleton(nameItem) : ofArray([pathItem, nameItem]))], react.createElement("div", keyValueList(props_8, 1), ...children_8)))))), delay(() => append(singleton_1(Item_div(empty(), singleton(button(append_1(model.SavedSheetIsOutOfDate ? empty() : singleton(new Option_4(/* Color */ 0, [Color_IColor.IsLight])), ofArray([new Option_4(/* Color */ 0, [Color_IColor.IsSuccess]), new Option_4(/* OnClick */ 18, [(_arg_7) => {
                    dispatch(new Msg(/* StartUICmd */ 109, [UICommandType.SaveSheet]));
                    dispatch(new Msg(/* FileCommand */ 111, [FileCommandType.FileSaveOpenFile, dispatch]));
                    dispatch(new Msg(/* Sheet */ 3, [DrawModelType_SheetT_Msg.DoNothing]));
                }])])), singleton("Save"))))), delay(() => append(singleton_1(Item_div(empty(), singleton(button(ofArray([new Option_4(/* OnClick */ 18, [(_arg_8) => {
                    viewInfoPopup(dispatch);
                }]), new Option_4(/* Color */ 0, [Color_IColor.IsInfo])]), singleton("Info"))))), delay(() => append(singleton_1(Item_div(empty(), equals(model.UISheetTrail, empty()) ? empty() : singleton(button(ofArray([new Option_4(/* OnClick */ 18, [(_arg_9) => {
                    dispatch(new Msg(/* SheetBackAction */ 5, [dispatch]));
                }]), new Option_4(/* Color */ 0, [Color_IColor.IsSuccess])]), singleton("Back"))))), delay(() => {
                    let props_12, children_12, props_10, children_10;
                    return singleton_1(End_div(empty(), ofArray([(props_12 = [["style", {
                        color: "#5282d1",
                        display: "flex",
                        width: "200px",
                        alignItems: "center",
                        textAlign: "center",
                    }]], (children_12 = [(props_10 = [["style", {
                        fontSize: "90%",
                    }]], (children_10 = getHintPaneElement(model), react.createElement("div", keyValueList(props_10, 1), ...children_10)))], react.createElement("div", keyValueList(props_12, 1), ...children_12))), Text_div(singleton(new Common_GenericOption(/* Props */ 1, [singleton(["style", {
                        paddingRight: "7000px",
                    }])])), singleton(""))])));
                }))))))));
            }))))));
        }));
    })))))];
    return react.createElement("div", keyValueList(props_14, 1), ...children_14);
}

